import { Link } from "react-router-dom";

const CustomButton = ({ text, to }) => {
  return (
    <Link
      to={to}
      className="w-[335px] h-[90px] bg-blue-500 text-white text-xl font-bold flex items-center justify-center mb-4 rounded-3xl shadow-slate-500 hover:bg-blue-600"
    >
      {text}
    </Link>
  );
};

export default CustomButton;
